
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatChipListbox, MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatCheckbox } from '@angular/material/checkbox';
import { AsyncPipe } from '@angular/common';

export interface ItemData {
    id?: string;
    item: string;
    selected: boolean;
    disabled: boolean;
}

@Component({
    selector: 'autocomplete-multiselect',
    templateUrl: './autocomplete-multiselect.component.html',
    styleUrls: ['./autocomplete-multiselect.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatChipListbox, MatChip, MatIcon, MatFormField, MatInput, MatAutocompleteTrigger, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatAutocomplete, MatOption, MatCheckbox, AsyncPipe]
})
export class AutocompleteMultiselectComponent implements OnInit {

    readonly result = output<{
    key: string;
    data: Array<string>;
}>();

    readonly placeholder = input<string>('Select Data');
    readonly data = input<Array<any>>([]);
    readonly key = input<string>('');
    readonly displayChipList = input<boolean>(true);


    selectControl = new FormControl();

    rawData: Array<ItemData> = [];
    selectData: Array<ItemData> = [];

    filteredData: Observable<Array<ItemData>>;
    filterString: string = '';

    constructor() {
        this.filteredData = this.selectControl.valueChanges.pipe(
            startWith<string>(''),
            map(value => typeof value === 'string' ? value : this.filterString),
            map(filter => this.filter(filter))
        );

    }

    ngOnInit(): void {

        for (let item of this.data()) {
            if (_.isString(item)) {
                this.rawData.push({ item, selected: false, disabled: false });
            } else {
                this.rawData.push({ id: item.id, item: item.item, selected: item.selected, disabled: item.disabled });
                if (item.selected === true) {
                    this.selectData.push(item);
                }
            }

        };
        console.log('this.selectData', this.selectData);
        this.selectControl.setValue(this.selectData);
        this.emitAdjustedData();



    }

    filter = (filter: string): Array<ItemData> => {
        this.filterString = filter;
        if (filter.length > 0) {
            return this.rawData.filter(option => {
                return option.item.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
            });
        } else {
            return this.rawData.slice();
        }
    };

    displayFn = (): string => '';

    optionClicked = (event: Event, data: ItemData): void => {
        event.stopPropagation();
        this.toggleSelection(data);
    };

    toggleSelection = (data: ItemData): void => {

        data.selected = !data.selected;

        if (data.selected === true) {
            this.selectData.push(data);
        } else {
            const i = this.selectData.findIndex(value => value.item === data.item);
            this.selectData.splice(i, 1);
        }

        this.selectControl.setValue(this.selectData);
        this.emitAdjustedData();
    };

    emitAdjustedData = (): void => {
        const results: Array<string> = [];
        this.selectData.forEach((data: ItemData) => {
            if (data.id) {
                results.push(data.id);
            } else {
                results.push(data.item);
            }
        });


        this.result.emit({ key: this.key(), data: results });
    };

    removeChip = (data: ItemData): void => {
        this.toggleSelection(data);
    };
}
